'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This is largely taken from react-router/lib/Link.


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function createLocationDescriptor(to, query, hash, state) {
  if (query || hash || state) {
    return { pathname: to, query: query, hash: hash, state: state };
  }

  return to;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

var propTypes = {
  onlyActiveOnIndex: _propTypes2.default.bool.isRequired,
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.func]).isRequired,
  query: _propTypes2.default.string,
  hash: _propTypes2.default.string,
  state: _propTypes2.default.object,
  action: _propTypes2.default.oneOf(['push', 'replace']).isRequired,
  onClick: _propTypes2.default.func,
  active: _propTypes2.default.bool,
  target: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};

var contextTypes = {
  router: _propTypes2.default.object
};

var defaultProps = {
  onlyActiveOnIndex: false,
  action: 'push'
};

var LinkContainer = function (_React$Component) {
  _inherits(LinkContainer, _React$Component);

  function LinkContainer() {
    var _temp, _this, _ret;

    _classCallCheck(this, LinkContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onClick = function (event) {
      var _this$props = _this.props,
          to = _this$props.to,
          query = _this$props.query,
          hash = _this$props.hash,
          state = _this$props.state,
          children = _this$props.children,
          onClick = _this$props.onClick,
          target = _this$props.target,
          action = _this$props.action;
      var router = _this.context.router;


      var toLocation = resolveToLocation(to, router);

      if (children.props.onClick) {
        children.props.onClick(event);
      }

      if (onClick) {
        onClick(event);
      }

      if (target || event.defaultPrevented || isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      event.preventDefault();

      router[action](createLocationDescriptor(toLocation, query, hash, state));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LinkContainer.prototype.render = function render() {
    var router = this.context.router;

    var _props = this.props,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        to = _props.to,
        children = _props.children,
        props = _objectWithoutProperties(_props, ['onlyActiveOnIndex', 'to', 'children']);

    var toLocation = resolveToLocation(to, router);

    props.onClick = this.onClick;

    // Ignore if rendered outside Router context; simplifies unit testing.
    if (router) {
      props.href = router.createHref(toLocation);

      if (props.active == null) {
        props.active = router.isActive(toLocation, onlyActiveOnIndex);
      }
    }

    return _react2.default.cloneElement(_react2.default.Children.only(children), props);
  };

  return LinkContainer;
}(_react2.default.Component);

LinkContainer.propTypes = propTypes;
LinkContainer.contextTypes = contextTypes;
LinkContainer.defaultProps = defaultProps;

exports.default = LinkContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-router-bootstrap/lib/LinkContainer.js
// module id = ./node_modules/react-router-bootstrap/lib/LinkContainer.js
// module chunks = 2